angular
    .module('lariAidApp').directive("autoFocus", function(){
    	return {
    		restrict:"A",
    		link: function(scope, element, attributes){
    			$(element).trigger("focus");
    		}
    	}
    });